import React from 'react'
import { render } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { store } from './store/store'
import { Provider } from 'react-redux'

// Production safety: CRA does NOT strip console.* from production builds, and
// several call sites log auth tokens, payment responses, the Stripe client
// secret, and customer PII. Silence log/info/debug in the shipped bundle so
// none of that reaches the customer's browser console. warn/error are kept so
// genuine problems stay visible (and available to any future error reporter).
if (process.env.NODE_ENV === 'production') {
  const noop = () => {}
  console.log = noop
  console.info = noop
  console.debug = noop
}

render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.querySelector('#root')
)